import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ContentBlockDataTable = lazy(() =>
  import("@scenes/MessageComposition/ContentBlocks/ContentBlockDataTable/ContentBlockDataTable").then((module) => ({
    default: module.ContentBlockDataTable,
  }))
);

export const contentBlocksNRO: NavigationRoutingObject = {
  Component: ContentBlockDataTable,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("content-block-templates-library", "Content Block Templates"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("content-blocks-description-nav", "Create blocks of HTML or text to reuse across messaging channels"),
  icon: "nav-system-content-blocks",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/content_blocks/:appGroupId",
};
